import Util from "@/helper/Utility.js";

export function HistoryPointConfigModel() {
    this.type = 'all'; // burn, earn, all
    this.top = 25;
    this.lastRowKey = null;
    this.month = null; // yyyy-mm-dd

    this.getParams = function() {
        var params = {
            type: this.type,
            top: this.top,
            lastRowKey: this.lastRowKey,
            month: this.month,
        };

        return Util.cleanObjectNullKey(params);
    };
}

export function HistoryPointConfigBuilder() {
    this.historyPointConfig = new HistoryPointConfigModel();

    this.create = function() {
        return this.historyPointConfig;
    };

    this.setType = function(type) {
        this.historyPointConfig.type = type;
        return this;
    };

    this.setTop = function(top) {
        this.historyPointConfig.top = top;
        return this;
    };

    this.setLastRowKey = function(lastRowKey) {
        this.historyPointConfig.lastRowKey = lastRowKey;
        return this;
    };

    /**
     * @param {string} month yyyy-mm-01
     * @returns
     */
    this.setMonth = function(month) {
        this.historyPointConfig.month = month;
        return this;
    };
}
